import { render, staticRenderFns } from "./benefits-terms-section.vue?vue&type=template&id=802b5020&scoped=true"
import script from "./benefits-terms-section.vue?vue&type=script&lang=js"
export * from "./benefits-terms-section.vue?vue&type=script&lang=js"
import style0 from "./benefits-terms-section.vue?vue&type=style&index=0&id=802b5020&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "802b5020",
  null
  
)

export default component.exports